import { render, staticRenderFns } from "./ShenPiNewFyBxChaiLv.vue?vue&type=template&id=d7950086&scoped=true&"
import script from "./ShenPiNewFyBxChaiLv.vue?vue&type=script&lang=js&"
export * from "./ShenPiNewFyBxChaiLv.vue?vue&type=script&lang=js&"
import style0 from "./ShenPiNewFyBxChaiLv.vue?vue&type=style&index=0&id=d7950086&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7950086",
  null
  
)

export default component.exports